class InviteUser {
	constructor(
		public readonly accountId: number,
		public readonly email: string,
		public readonly firstName: string,
		public readonly lastName: string,
		public readonly roleId: number,
		public readonly organizationIds: readonly number[],
		public readonly facilityIds: readonly number[],
		// Bare value (`'password'` / `'sso'`), never the `{ value, label }` object read back on `UserView`.
		public readonly authenticationMode: string,
	) {
		Object.freeze(this);
	}

	// `accountId` is the route identifier: it must never be echoed in the request body.
	toJSON(): Record<string, unknown> {
		return {
			email: this.email,
			firstName: this.firstName,
			lastName: this.lastName,
			roleId: this.roleId,
			organizationIds: this.organizationIds,
			facilityIds: this.facilityIds,
			authenticationMode: this.authenticationMode,
		};
	}
}

export default InviteUser;
